import { createSvgIcon } from 'src/components/Icons/utils';

export default createSvgIcon(
  <path d="M8 3v9a4 4 0 1 0 8 0V3h2v9a6 6 0 1 1-12 0V3h2zM4 20h16v2H4v-2z" />,
  'Underline',
  '0 0 24 24'
);
